import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { OmView } from '@xingternal/platform-layout-om';
import { BodyCopy, Headline } from '@xingternal/typography';
import { Button } from '@xingternal/button';
import cx from 'classnames';

import { UserChoicesTypes, ModalConfigurationTypes } from './types';
import containerStyles from './CookieConsentContainer.css';
import sharedStyles from './shared.css';
import styles from './ConsentBanner.css';
import CookieSettings from './CookieSettings';

const acceptInternalSelected =
  (hideOmView, acceptSelected, tttService) => (userChoices) => {
    tttService.trackAcceptMarketing(userChoices);
    hideOmView();
    acceptSelected(userChoices);
  };

const acceptInternalAll =
  (acceptAll, tttService, hideOmView = () => {}) =>
  () => {
    tttService.trackAcceptAll();
    hideOmView();
    acceptAll();
  };

const ConsentBanner = ({
  resources,
  acceptAll,
  acceptSelected,
  setShowSettings,
  userChoices,
  tttService,
}) => {
  const [newUserChoices, setNewUserChoices] = useState(userChoices);

  return (
    <div className={cx(containerStyles.container, styles.container)}>
      <div className={styles.banner}>
        <div className={styles.bannerText}>
          <Headline
            as="h2"
            id={'consent-banner-title'}
            className={styles.bannerTitle}
          >
            {resources.banner.title}
          </Headline>
          <BodyCopy
            className={cx(
              sharedStyles.text,
              sharedStyles.bigText,
              styles.description,
              'consent-banner-description'
            )}
            id={'consent-banner-text'}
            dangerouslySetInnerHTML={{ __html: resources.banner.body }}
          />
        </div>
        <div className={styles.buttonContainer}>
          <OmView
            className={styles.settingsContainer}
            onClose={() => {
              tttService.trackHideSettings();
              setShowSettings(false);
            }}
            trigger={(activateOmView) => (
              <Button
                onClick={() => {
                  tttService.trackShowSettings();
                  activateOmView();
                  setShowSettings(true);
                }}
                id={'consent-settings-button'}
                data-qa={'consent-button-settings'}
                className={cx(
                  'consent-banner-button-settings',
                  styles.reviewButton
                )}
                variant="text"
                size="medium"
              >
                {resources.banner.reviewButton}
              </Button>
            )}
          >
            {({ handleClose }) => (
              <CookieSettings
                resources={resources.modal}
                userChoices={newUserChoices}
                setUserChoices={setNewUserChoices}
                showSettings={setShowSettings}
                handleAcceptAll={acceptInternalAll(
                  acceptAll,
                  tttService,
                  handleClose
                )}
                acceptChoices={acceptInternalSelected(
                  handleClose,
                  acceptSelected,
                  tttService
                )}
              />
            )}
          </OmView>
          <Button
            id={'consent-accept-button'}
            variant="primary"
            size="medium"
            className={cx(
              'consent-banner-button-accept-all',
              styles.acceptButton
            )}
            onClick={acceptInternalAll(acceptAll, tttService)}
          >
            {resources.banner.acceptAllButton}
          </Button>
        </div>
      </div>
    </div>
  );
};

ConsentBanner.propTypes = {
  userChoices: UserChoicesTypes,
  resources: PropTypes.shape({
    banner: PropTypes.shape({
      body: PropTypes.string,
      title: PropTypes.string,
      reviewButton: PropTypes.string,
      acceptAllButton: PropTypes.string,
    }),
    modal: ModalConfigurationTypes,
  }).isRequired,
  acceptAll: PropTypes.func.isRequired,
  acceptSelected: PropTypes.func.isRequired,
  setShowSettings: PropTypes.func.isRequired,
  tttService: PropTypes.object.isRequired,
};

export default ConsentBanner;
